export default class ModelGenerationRequest {
    organizationId = null;
    assetId = null;
    scanId = null;

    constructor(organizationId, assetId, scanId){
        this.organizationId = organizationId;
        this.assetId = assetId;
        this.scanId = scanId;
    }
}